'use strict';

class recipientService {
  constructor($http) {
    this.$http = $http;
  }

  list(params) {
    return this.$http.get(`/recipients/all`, {
      params: params
    });
  }

  filter(type = 'mostUsed', params = {}) {
    return this.$http.get(`/recipients/filter/${type}`,
      {
        params: params
      }
    ).then((resp) => resp.data);
  }

  // FILTERS
  getLetter(query, offset, limit) {
    return this.$http.get(`/recipients/filter/alphabet/${query}`, {
      params: {
        offset: offset,
        limit: limit
      }
    });
  }

  getCity(query, offset, limit) {
    return this.$http.get(`/recipients/filter/city/${query}`, {
      params: {
        offset: offset,
        limit: limit
      }
    });
  }

  getCountry(query, offset, limit) {
    return this.$http.get(`/recipients/filter/country/${query}`, {
      params: {
        offset: offset,
        limit: limit
      }
    });
  }

  getField(number, query) {
    return this.$http.get(`/recipients/searchByCustomField?number=${number}&value=${query}`);
  }

  getLabelFilter(query, offset, limit) {
    return this.$http.get(`/recipients/filter/label/${query}`, {
      params: {
        offset: offset,
        limit: limit
      }
    });
  }

  // RECIPIENT
  search(name, limit) {
    return this.$http.get(`/recipients/searchForRecipients`, {
      params: {
        name: name,
        limit: limit
      }
    });
  }

  get(number) {
    return this.$http.get(`/recipients/${number}`);
  }

  getBy(term, number) {
    return this.$http.get(`/recipients/?${term}=${number}`);
  }

  save(recipient) {
    return this.$http.post(`/recipients/`, recipient);
  }

  update(number, recipient) {
    return this.$http.put(`/recipients/${number}`, recipient);
  }

  updateOrgNo(number, recipient) {
    return this.$http.put(`/recipients/${number}/orgNo`, recipient);
  }

  remove(number) {
    return this.$http.delete(`/recipients/${number}`);
  }

  deleteNonInvoiceRecipientData(number) {
    return this.$http.delete(`/recipients/${number}/non-invoice`);
  }

  restore(number) {
    return this.$http.post(`/recipients/${number}/restore`);
  }

  // UTILS
  suggestCustomerNumber() {
    return this.$http.get(`/recipients/suggest`);
  }

  searchBasedOnParticipant(params = {}) {
    return this.$http.get(`/recipients/basedOnParticipant`, params);
  }

  // DOCUMENTS
  getDrafts(number) {
    return this.$http.get(`/recipients/${number}/drafts`);
  }

  getOrderConfirmations(number) {
    return this.$http.get(`/recipients/${number}/orderConfirmations`);
  }

  getOffers(number) {
    return this.$http.get(`/recipients/${number}/offers`);
  }

  getInvoices(number) {
    return this.$http.get(`/recipients/${number}/invoices`);
  }

  getBalance(number) {
    return this.$http.get(`/sales-ledger/recipients/${number}/balance`);
  }

  // LABELS
  getLabels(number) {
    return this.$http.get(`/recipients/${number}/labels`);
  }

  // CUSTOM FIELDS
  getCustomFields() {
    return this.$http.get(`/recipients/custom-fields`);
  }

  getCustomField(number) {
    return this.$http.get(`/recipients/custom-fields/${number}`);
  }

  setCustomField(field) {
    return this.$http.post(`/recipients/custom-fields`, field);
  }

  deleteCustomField(number) {
    return this.$http.delete(`/recipients/custom-fields/${number}`);
  }
}

recipientService.$inject = ['$http'];

angular
  .module('SendRegning')
  .service('recipientService', recipientService);
